import { PageController } from '@client/components/_core/layout/PageController';
import { VDatePicker } from '@client/components/_shared/forms/view-form/VDatePicker';
import { VDropdown } from '@client/components/_shared/forms/view-form/VDropdown';
import { VReadOnly } from '@client/components/_shared/forms/view-form/VReadOnly';
import { VTextInput } from '@client/components/_shared/forms/view-form/VTextInput';
import { productVersionFormStore } from '@client/components/products-v2/store';
import { useFormatter } from '@client/hooks/utils/useFormatter';
import type { CoverageBasis } from '@shared/prisma/enums';
import { createFileRoute } from '@tanstack/react-router';
import { Card } from 'antd';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details',
)({
    staticData: {
        ui: {
            useParentTitle: false,
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <Details />
        </PageController>
    );
}

const COVERAGE_BASIS_LABELS: Record<CoverageBasis, string> = {
    OCCURRENCE: 'Occurrence',
    CLAIMS_MADE: 'Claims-made',
    CLAIMS_MADE_AND_NOTIFIED: 'Claims-made and notified',
};

function Details() {
    const { formatDate } = useFormatter();

    return (
        <Card
            size="small"
            title="Version details"
            classNames={{
                root: 'max-w-2xl',
                body: 'space-y-4',
            }}
        >
            <VTextInput label="Name" field="name" formStore={productVersionFormStore} />
            <VDropdown
                label="Coverage basis"
                field="coverageBasis"
                formStore={productVersionFormStore}
                allowClear
                options={Object.entries(COVERAGE_BASIS_LABELS).map(([value, label]) => ({ value, label }))}
            />
            <div className="grid grid-cols-2 gap-4">
                <VDatePicker
                    label="Launch date"
                    field="startDate"
                    formStore={productVersionFormStore}
                    showTime={{ format: 'HH:mm' }}
                />
                <VReadOnly
                    label="End date"
                    field="endDate"
                    formStore={productVersionFormStore}
                    tooltip="Auto-populated when the next version is published, or set manually if the product ends."
                    formatValueFn={(value) => (value ? formatDate(value) : '-')}
                />
            </div>
        </Card>
    );
}
